import React, {useState, useEffect,useContext} from "react";
import { useTranslate } from 'react-redux-multilingual';
import { CardPerso,ArticleFilterSearch2} from "@gull";
import axios from 'axios'
import swal from "sweetalert2";
import { useParams } from "react-router-dom";
import { articleHardData } from 'app/articleHardData';
import { Modal } from "react-bootstrap";
import ModalAddItemToList from './ModalAddItemToList'
import { IsAuthContext } from 'app/App';

const useLoadInit = (fromComponent,promoId,selectedList) => {
    const t = useTranslate();
    const [loading,setLoading]=useState(false)
    const [sizeDatas,setSizeDatas]=useState(0)
    const [relance, setRelance] =useState(Date.now())
    const [sendData, setSendData] = useState({})
    const [filtre,setFiltre] = useState({})
    const [goFiltre,setGoFiltre]=useState(false) 
    const [showModalAdd,setShowModalAdd]=useState(false) 
    const [selectedArticleList,setSelectedArticleList]=useState([]) 
    const [selectValue,setSelectValue]=useState({
        list:'1',
        action:'ajout',
        qteArticleListe:''
    });
    const [listeFiltreDynamicGeneral,setListeFiltreDynamicGeneral]=useState(false)
    const [listeFiltreDynamicA,setListeFiltreDynamicA]=useState([]) 
    const [listeFiltreDynamicB,setListeFiltreDynamicB]=useState([]) 

    useEffect(function () {
        (async function() {
            if(goFiltre){
                setLoading(true)
                const response = await axios.post(process.env.REACT_APP_API_URL+"api/erp/article/list_no_pagination",filtre
                ).then((response) => {
                    setGoFiltre(false)
                    setLoading(false)
                    setSizeDatas(response.data.count)
                    setSelectedArticleList(response.data.datas)
                }).catch((error) => {
                    if(error=='end_session') return;
                    let messageError
                    if(error.response==undefined){
                        messageError='unknowError'
                    }
                    else if(error.response.status==403){
                        messageError='forbiddenGeneral'
                    }
                    else {
                        messageError='unknowError'
                    }
                    
                    swal.fire(t(messageError), "", "error");
                    setLoading(false)
                })
            }
        })()
    }, [relance])

    useEffect(function () {
        (async function() {
            if(fromComponent=='promo'){
                const response = await axios.get(process.env.REACT_APP_API_URL+"api/erp/filtre/get_all/"+promoId
                ).then((response) => {
                    let arrA = []
                    let arrB = []
                    response.data.datas.map(list=>{
                        if(list.liste=='1'){
                            arrA.push(list)
                        }else{
                            arrB.push(list)
                        }
                    })
                    // Trier du plus ancien au plus récent
                    setListeFiltreDynamicA(arrA.sort((a, b) => new Date(a.created_at) - new Date(b.created_at)))
                    setListeFiltreDynamicB(arrB.sort((a, b) => new Date(a.created_at) - new Date(b.created_at)))
                    if(selectedList=='listA'){//à l'arrivé sur la page, on affiche la liste des filtres dynamique selon 
                        setListeFiltreDynamicGeneral(arrA.sort((a, b) => new Date(a.created_at) - new Date(b.created_at)))
                    }else{
                        setListeFiltreDynamicGeneral(arrB.sort((a, b) => new Date(a.created_at) - new Date(b.created_at)))
                    }
                }).catch((error) => {
                    if(error=='end_session') return;
                    let messageError
                    if(error.response==undefined){
                        messageError='unknowError'
                    }
                    else if(error.response.status==403){
                        messageError='forbiddenGeneral'
                    }
                    else {
                        messageError='unknowError'
                    }
                    
                    swal.fire(t(messageError), "", "error");
                })
            }
        })()
    }, [])
    
    return [loading,setSizeDatas,sizeDatas,setRelance,sendData,setSendData,filtre,setFiltre,setGoFiltre,showModalAdd,setShowModalAdd,selectValue,setSelectValue,selectedArticleList,listeFiltreDynamicA,setListeFiltreDynamicA,listeFiltreDynamicB,setListeFiltreDynamicB,listeFiltreDynamicGeneral,setListeFiltreDynamicGeneral]
}

const AddItemToList = (props) => {
    const t = useTranslate();
    const { id } = useParams();
    const [loading,setSizeDatas,sizeDatas,setRelance,sendData,setSendData,filtre,setFiltre,setGoFiltre,showModalAdd,setShowModalAdd,selectValue,setSelectValue,selectedArticleList,listeFiltreDynamicA,setListeFiltreDynamicA,listeFiltreDynamicB,setListeFiltreDynamicB,listeFiltreDynamicGeneral,setListeFiltreDynamicGeneral] = useLoadInit(props.from,id,props.selectedList)
    const [showModalCustomFiltre, setShowModalCustomFiltre] = useState(false);
    const [disabledAddSelection,setDisabledAddSelection]=useState(true) 
    const [validButton,setValidButton]=useState(false) 
    const [loadingDeleteFiltre,setLoadingDeleteFiltre]=useState(false) 
    const [disabledSelectAction,setDisabledSelectAction]=useState(false) 
    const [success,setSuccess]=useState(false) 
    const [dynamicFilterId,setDynamicFilterId]=useState('') 
    const { authParam } = useContext(IsAuthContext);
    const moduleErp = authParam.modules.find(value=>value.name=='erp')

    useEffect(function () {
        if(props.selectedList && listeFiltreDynamicGeneral){
            if(props.selectedList=='listA'){
                setListeFiltreDynamicGeneral(listeFiltreDynamicA)
            }else{
                setListeFiltreDynamicGeneral(listeFiltreDynamicB)
            }
        }
    }, [props.selectedList])

    useEffect(function () {
        const isAnyKeyNonEmptyArray = Object.values(sendData).some(value => Array.isArray(value) && value.length > 0);

        if(isAnyKeyNonEmptyArray){
            setDisabledAddSelection(false)
        }else{
            setDisabledAddSelection(true) 
        }
    }, [sendData])

    const resetFiltreItemsToPromo = () =>{
        setGoFiltre(true)
        setDynamicFilterId(false)
        let allFilter = {}
        let keysToReset = Object.keys(sendData).filter(key=> key != Object.keys(allFilter).find(value=>value===key))

        keysToReset.map(value=>
            allFilter[value]=[]
        )

        setSendData(allFilter)
        setFiltre({})
        // setRelance(Date.now())
        setSizeDatas(false)
    }
    
    const addItemsSubmit = async (ItemsToAdd) =>{
        setValidButton(true)

        if(props.from=='promo'){
            //Dans une promo on procède à l'enregistrement des filtres sélectionnés afin d'avoir un mise à jour automatique sur ce filtrage en cas d'ajout de nouveaux articles concerncés par ce filtre
            let endUrl = dynamicFilterId=='' ? 'create' : 'edit/'+dynamicFilterId
            let axiosMethod = dynamicFilterId=='' ? axios.post : axios.put

            const response = await axiosMethod(process.env.REACT_APP_API_URL+"api/erp/filtre/"+endUrl, {
                promotion_id:id,
                liste:(props.selectedList=="listA") ? 1 : 2,
                add:selectValue.filterSaveAddItemToList,
                value:{...sendData}
            }).then((response) => {
                if(dynamicFilterId==''){ 
                    //Dans le cas d'une création de filtre dynamique 
                    setListeFiltreDynamicGeneral([...listeFiltreDynamicGeneral,response.data.data])
                    if(props.selectedList=='listA'){
                        setListeFiltreDynamicA([...listeFiltreDynamicGeneral,response.data.data])
                    }else{
                        setListeFiltreDynamicB([...listeFiltreDynamicGeneral,response.data.data])
                    }
                }
                resetFiltreItemsToPromo()
                setValidButton(false)
                setShowModalAdd(false)
            }).catch((error) => {
                if(error=='end_session') return;
                let messageError
                if(error.response==undefined){
                    messageError='unknowError'
                }
                else if(error.response.status==403){
                    messageError='forbiddenGeneral'
                }
                else {
                    messageError='unknowError'
                }
                
                swal.fire(t(messageError), "", "error");
            })
        }
        else if(props.from=='itemList'){
            let listArticleId = []
            let listQteArticle = []

            selectedArticleList.forEach(value=>{
                listArticleId.push(value.id)
                if(selectValue.qteArticleListe!=''){
                    //Si on renseigne une quantité par défaut, on l'ajoute aux articles de la sélectionn sinon on envoie 1 
                    listQteArticle.push(selectValue.qteArticleListe)
                }else{
                    listQteArticle.push(1)
                }
            })

            let obj ={
                article_list: props.articleListeId,
                articles: listArticleId,
                quantity: listQteArticle,
                zone: props.zoneArticleListe
            }

            props.handleSubmitArticleListe(obj,setValidButton,resetFiltreItemsToPromo,setShowModalAdd)

        }else if(props.from=='fideliteRecompenseConfigure'){
            let obj = {
                ...ItemsToAdd,
            }

            const response = await axios.post(process.env.REACT_APP_API_URL+props.urlAddItems+props.cumulPointVal, obj
            ).then((response) => {
                if(!response.data.valid){
                    let interms='';
                    var keys = Object.keys(response.data.errors);
                    for(var i = 0; i < keys.length; i++){
                        interms+=response.data.errors[keys[i]].join(',')+','
                    }
                    interms=interms.split(',')
                    let messageError='';
                    interms.forEach(interm=>messageError+=t(interm)+'. ')
                    messageError=messageError.replace('undefined','');
                    swal.fire(messageError, "", "error");
                }
                else {
                    props.setCumulPointVal('')
                    props.setParamFidelite([response.data.datas,...props.paramFidelite])
                    resetFiltreItemsToPromo()
                    setValidButton(false)
                    setShowModalAdd(false)
                }
            }).catch((error) => {
                if(error=='end_session') return;
                let messageError
                if(error.response==undefined){
                    messageError='unknowError'
                }
                else if(error.response.status==403){
                    messageError='forbiddenGeneral'
                }
                else {
                    messageError='unknowError'
                }
                
                swal.fire(t(messageError), "", "error");
                setValidButton(false)
            })
        }else if(props.from=='supplementList'){
            let obj ={
                articles: selectedArticleList.map(value => ({ id: value.id, article_price_id: null })),
                action:selectValue.action
            }

            props.handleSubmitArticleListe(obj,setValidButton,resetFiltreItemsToPromo,setShowModalAdd)

        }else if (props.from=='stockAdjustment') {
            let obj=[]

            selectedArticleList.forEach(value=>{
                obj.push({article:value,quantity:1})
            })
            props.handleSubmitArticleListe(obj,setValidButton,resetFiltreItemsToPromo,setShowModalAdd)
        }else{
            let obj = {
                ...ItemsToAdd,
                action:selectValue.action
            }
            
            const response = await axios.post(process.env.REACT_APP_API_URL+props.urlAddItems+((props.from=='personalized_price')?props.promotionDetail.id:id), obj
            ).then((response) => {
                resetFiltreItemsToPromo()
                setValidButton(false)
                setShowModalAdd(false)
                setSelectValue({
                    list:'1',
                    action:'ajout'
                }) 
                if(selectValue.list=='1'){//Pour les promos, selon la liste d'article à remplir on vérifie laquelle on veut relancer, mais par défaut en relance la liste une 
                    props.setReload(Date.now())
                }else{
                    props.setReloadSecond(Date.now())
                }
            }).catch((error) => {
                if(error=='end_session') return;
                let messageError
                if(error.response==undefined){
                    messageError='unknowError'
                }
                else if(error.response.status==403){
                    messageError='forbiddenGeneral'
                }
                else {
                    messageError='unknowError'
                }
                
                swal.fire(t(messageError), "", "error");
                setValidButton(false)
            })
        }
    }

    const filterItemsPromo = (data) =>{
        setGoFiltre(true)

        let obj={}

        if(data){
            Object.entries(data).map(([key,value])=>{
                obj[key]=value
            })      
        }else{
            let keys = Object.keys(sendData);
            for(var i = 0; i < keys.length; i++){
                if(Array.isArray(sendData[keys[i]])){
                    obj[keys[i]]=[]
                    sendData[keys[i]].forEach(value=>obj[keys[i]].push(value.id))
                }
                else{
                    obj[keys[i]]=sendData[keys[i]]
                }
            }
        }
        
        setFiltre(obj)
        if(props.from=='promo'){
            addItemsSubmit(obj)
        }else{
            setShowModalAdd(obj)
        }
        setRelance(Date.now())
    }

    const handleSelect = (e,nameInput) => {
        setSendData({...sendData,[nameInput]:e.target.value})
    }

    const changeActionDynamicFilter = (e) => {
        setDisabledSelectAction(true)
        let addPayload = e.target.value=='1' ? true : false
        const response = axios.post(process.env.REACT_APP_API_URL+'api/erp/promotion/filtre_add/'+props.promotionDetail.id, {
            add:addPayload
        }).then((response) => {
            setSuccess(true)
            setDisabledSelectAction(false)
            props.setPromotionDetail(response.data.datas)
        }).catch((error) => {
            if(error=='end_session') return;
            let messageError
            if(error.response==undefined){
                messageError='unknowError'
            }
            else if(error.response.status==403){
                messageError='forbiddenGeneral'
            }
            else {
                messageError='unknowError'
            }
            swal.fire(t(messageError), "", "error");
            setDisabledSelectAction(false)
        })
        setTimeout(() => {
            setSuccess(false)
        }, 1500);
    };

    const deleteDynamicFilter = () => {
        setLoadingDeleteFiltre(true)
        const response = axios.delete(process.env.REACT_APP_API_URL+'api/erp/filtre/delete/'+dynamicFilterId, 
        ).then((response) => {
            resetFiltreItemsToPromo()
            let newList = listeFiltreDynamicGeneral.filter(dynamicFilter => dynamicFilter.id != dynamicFilterId)
            setListeFiltreDynamicGeneral(newList)
            if(props.selectedList=='listA'){
                setListeFiltreDynamicA(newList)
            }else{
                setListeFiltreDynamicB(newList)
            }
        }).catch((error) => {
            if(error=='end_session') return;
            let messageError
            if(error.response==undefined){
                messageError='unknowError'
            }
            else if(error.response.status==403){
                messageError='forbiddenGeneral'
            }
            else {
                messageError='unknowError'
            }
            swal.fire(t(messageError), "", "error");
            setLoadingDeleteFiltre(false)
        })
    };

    return (<>
        <Modal show={showModalAdd} onHide={() => setShowModalAdd(false)} backdrop="static" keyboard={false}>
            <Modal.Header closeButton>
                <Modal.Title>{t(props.from=='promo' ? 'dynamicUpdateByFilter' : 'addItems')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ModalAddItemToList 
                    loading={loading} 
                    sizeDatas={sizeDatas} 
                    selectValue={selectValue} 
                    setSelectValue={setSelectValue} 
                    addItemsSubmit={addItemsSubmit} 
                    showModalAdd={showModalAdd} 
                    setShowModalAdd={setShowModalAdd}
                    validButton={validButton}
                    relatedItemsList={props.relatedItemsList}
                    from={props.from}
                    articleListInfo={props.articleListInfo}//passé depuis les listes d'article 
                />
            </Modal.Body>
        </Modal>
        <CardPerso header={
                <span className="d-flex justify-content-between align-items-center">
                    {t(props.from=='promo' ? 'dynamicUpdateByFilter' : 'itemsSelection')}
                    <span>
                        <button 
                            className="btn btn-danger" 
                            onClick={()=>props.setShowAccordion(false)}
                        >{t('btnClose')}
                        </button>
                    </span>
                </span>
            }>
            {props.children}
            {(props.cumulPointVal == undefined || props.cumulPointVal!='' ) &&
                <div className="row">
                    {props.from=='promo' &&
                        <div className="mb-3">
                            <label className="fw-bold">{t('actionOnDynamicFilter')}</label>
                            <select 
                                disabled={disabledSelectAction} 
                                defaultValue={props.promotionDetail && props.promotionDetail.filtre_add!=null ? props.promotionDetail.filtre_add : ''} 
                                className="form-control"
                                onChange={(e)=>changeActionDynamicFilter(e)}
                            >
                                {props.promotionDetail && props.promotionDetail.filtre_add==null &&
                                    <option value="">-- Select --</option>
                                }
                                <option value="1">{t('additionToList')}</option>
                                <option value="0">{t('replacementOfTheList')}</option>
                            </select>
                            {(success) ? <div className="alert alert-success mt-2">{t('successOperation')}</div> : false}
                        </div>
                    }
                    <div className="col">
                        {(props.from!='promo' || (props.from=='promo' && props.promotionDetail && props.promotionDetail.filtre_add!=null)) ?
                            <ArticleFilterSearch2
                                liaisons={props.liaisons}
                                sizeDatas={sizeDatas}
                                customFields={props.customFields}
                                setSizeDatas={setSizeDatas} 
                                setFiltre={setFiltre}
                                setReload={props.setReload}
                                customInterface={props.customInterface}
                                setCustomInterface={props.setCustomInterface}
                                sendData={sendData}
                                setSendData={setSendData}
                                setShowModalCustomFiltre={setShowModalCustomFiltre}
                                showModalCustomFiltre={showModalCustomFiltre}
                                initAllFilter={{}}
                                interface='filtreArticle' //Variable qui permet d'identifier l'url sur laquelle filtrer
                                hardData={articleHardData}
                                moduleName='items'

                                tableName={props.tableName}
                                setToast={props.setToast}

                                addItemPromoBtn='true'
                                from={props.from}
                                resetFiltreItemsToPromo={resetFiltreItemsToPromo}
                                filterItemsPromo={filterItemsPromo}
                                disabledAddSelection={disabledAddSelection}
                                loading={loading}
                                dynamicFilterId={dynamicFilterId}
                                setDynamicFilterId={setDynamicFilterId}
                                listeFiltreDynamicGeneral={listeFiltreDynamicGeneral}
                                deleteDynamicFilter={deleteDynamicFilter}
                                loadingDeleteFiltre={loadingDeleteFiltre}
                            >
                                <div className="row d-flex justify-content-between">
                                    {(moduleErp.params.stock.active) &&
                                        <div className="col-3">
                                            <div className="form-group">
                                                <label className="col-form-label col-form-label-sm">{t('itemHaveStock')}</label>
                                                <select className="form-control form-control-sm" value={sendData.havestock} onChange={(e) => handleSelect(e,'havestock')}>
                                                    <option value="">{t('itemLinkAndNotLinkToTock')}</option>
                                                    <option value="oui">{t('itemLinkToTock')}</option>
                                                    <option value="non">{t('itemNotLinkToTock')}</option>
                                                </select>
                                            </div>
                                        </div>
                                    }       
                                    
                                </div>
                            </ArticleFilterSearch2>
                        :
                            false
                        }
                    </div>
                </div>
            }
        </CardPerso>
        </>
    )
}

export default AddItemToList;
